import {HttpClient, HttpHandler} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Session} from 'src/app/interfaces/session-data';
import {share} from 'rxjs/operators';

@Injectable()

export class TransactionApi extends HttpClient {
    private baseUrl = environment.production ? "/channel-virtual/api/v1" + '/transaction' : environment.baseUrl + '/transaction';

    public constructor(handler: HttpHandler) {
        super(handler);
    }
// Observable<any>
    public getPaymentOptions(data: Session): void {

      //   let url = this.baseUrl + `/paymentOptions?amount=${data.amount}&currencyCode=${data.currencyCode}&applicationUid=${data.applicationId}&merchantUid=${data.merchantId}&merchantReference=${data.merchantReference}&originatingTransactionId=${data.originatingTransactionId}`;
      //
      //   data.keyValuePairs.forEach((element) => {
      //     if (element.key === 'firstName') {
      //       url += `&firstName=${element.value}`;
      //     }
      //     else if (element.key === 'lastName') {
      //       url += `&lastName=${element.value}`;
      //     }
      //     else if (element.key === 'msisdn') {
      //       url += `&msisdn=${element.value}`;
      //     }
      //     else if (element.key === 'description') {
      //       url += `&description=${element.value}`;
      //     }
      //     else if (element.key === 'email') {
      //       url += `&email=${element.value}`;
      //     }
      //   });
      //
        // return super.get(url);
      }

    public getTransactionStatus(originatingTransactionId): Observable<any> {
        const url = this.baseUrl + `/transactionStatus?originatingTransactionId=${originatingTransactionId}`;
        console.log('getTransactionStatus', url);
        return super.get(url)
        .pipe(share());
    }

    public getTransactionStatusCard(sessionToken: string): Observable<any> {
      const url = this.baseUrl + `/status/${sessionToken}`;
      console.log(' getTransactionStatusCard', url);
      return super.get(url);
    }

    public updateTransactionStatus(transactionId: string, body: object): Observable<any> {
        const url = this.baseUrl + `/updateTransactionStatus/${transactionId}`;
        console.log('updateTransactionStatus', url);
        return super.put(url, body);
    }

    public postPaymentData(body: Object) {
      const url = this.baseUrl + `/processPayment`;
      return super.post(url, body);
    }

    public postPaymentStatus(body: Object) {
      const url = this.baseUrl + `/updatePaymentStatus`;
      return super.post(url, body);
    }

}
